const baseSpoilerData = {};
const SpoilerData = {
  fromJSON(object) {
    const message = { ...baseSpoilerData };
    message.id = object.id !== void 0 && object.id !== null ? String(object.id) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.id !== void 0 && (obj.id = message.id);
    return obj;
  }
};
export {
  SpoilerData
};
//# sourceMappingURL=decoration_spoiler.js.map
